import React from 'react';
import './CategoryRequirementsModal.css';
import { CategoryInfo, CategoryRequirementsModalProps } from '../../types';

const CategoryRequirementsModal: React.FC<CategoryRequirementsModalProps> = ({ category, onClose }) => {
  if (!category) return null;

  return (
    <div className="category-modal-overlay" onClick={onClose}>
      <div className="category-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="category-modal-header">
          <h2>{category.name}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="category-modal-body">
          <div className="category-description-section">
            <p className="category-description-text">{category.description}</p>
          </div>

          <div className="requirements-section">
            <h3>Requirements & Criteria</h3>
            <ul className="requirements-list">
              {category.criteria.map((requirement, index) => (
                <li key={index} className="requirement-item">
                  <span className="requirement-check">✓</span>
                  <span className="requirement-text">{requirement}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryRequirementsModal;

